import * as React from "react";

import { Card } from "../Card";

export interface FormSectionProps {
  title: string;
  /** What the section is for; the same sentence in read and edit mode. */
  hint?: string;
  children: React.ReactNode;
  /** A control that belongs beside the title (a "View sample" link, a toggle). */
  actions?: React.ReactNode;
  /**
   * Id put on the heading, for an input inside the block to point at with
   * `aria-labelledby` so its accessible name is the section's own title.
   */
  titleId?: string;
  className?: string;
  dataCy?: string;
}

/**
 * One section of a form or detail page: a section `Card` whose header carries
 * the title and the hint, ruled off from the fields below. Shared across the
 * app's forms so their sections look alike; the skill pages and the trigger
 * editor both build on it.
 */
export function FormSection({
  title,
  hint,
  children,
  actions,
  titleId,
  className,
  dataCy,
}: FormSectionProps) {
  return (
    <Card.Root className={className} data-cy={dataCy}>
      <Card.Header>
        <Card.Title id={titleId}>{title}</Card.Title>
        {actions !== undefined && <Card.Actions>{actions}</Card.Actions>}
        {hint !== undefined && <Card.Description>{hint}</Card.Description>}
      </Card.Header>
      <Card.Body>{children}</Card.Body>
    </Card.Root>
  );
}
